import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import addon_sensors, {
	addon_plus_devices_g3,
} from '@devices/settings/device_settings/addon_sensors.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import share from '@devices/settings/device_settings/share.js';
import emeter_settings_gen_3 from '@devices/settings/device_settings/emeter_settings_gen_3.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';
import energy_category from '@devices/settings/device_settings/energy_category.js';

export default {
	name: 'ShellyEMG3',
	friendly_name: 'EM Gen3',
	family: 'emeter',
	isPM: true,
	addons: addon_plus_devices_g3,
	modes: {
		emeter: {
			availableViews: ['basic'],
			channels: 2,
			notifications: ['offline', 'device_problem', 'overpower', 'overvoltage'],
			phases: 2,
			settings: [
				{
					title: 'timer',
					components: [{ title: 'auto', component: 'auto_gen_2_emeter' }],
				},
				schedule_gen_2,
				webhooks_gen_2,
				addon_sensors,
				scripts_gen_2,
				virtual_components,
				networks_gen_2_plus,
				bluetooth_gen_2,
				{
					title: 'application_settings',
					components: [
						{ title: 'ai_model', component: 'ai_model' },
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
						energy_category,
						{
							title: 'consumption_calculation',
							component: 'consumption_calculation',
						},
						{
							title: 'consumption_hierarchy',
							component: 'consumption_hierarchy',
							test_user: true,
						},
						{ title: 'pin_lock', component: 'pin_lock' },
						{ title: 'exclude_event_log', component: 'exclude_event_log' },
					],
				},
				share,
				emeter_settings_gen_3,
			],
		},
	},
};
